import { render } from "./RegistrationClinicStepThree.vue?vue&type=template&id=044de888&scoped=true"
import script from "./RegistrationClinicStepThree.vue?vue&type=script&lang=js"
export * from "./RegistrationClinicStepThree.vue?vue&type=script&lang=js"

import "./RegistrationClinicStepThree.vue?vue&type=style&index=0&id=044de888&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-044de888"]])

export default __exports__